import React, { useEffect, useState } from "react";
import Product from "../components/product/ProductSelects";
import {
  Modal,
  Tag,
  Row,
  Table,
  Select,
  Button,
  Space,
  Form,
  Col,
  Input,
  InputNumber,
  Card,
} from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import ProductSelectOrder from "../components/product/ProductSelectOrder";
import { LocalImage } from "../components/ImageUtil";
import { currencyFormat } from "../utils/index";
import { useSelector, useDispatch } from "react-redux";

import { productActions } from "../store";

const ProductUtil = () => {
  const confirm = Modal.confirm;
  const { form } = Form.useForm();
  const { Option } = Select;
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const [products, setProducts] = useState([]);
  const [productSelects, setProductSelects] = useState([]);

  const { productSelectOrder } = useSelector((x) => x.product);

  useEffect(() => {
    dispatch(productActions.setProductSelects(products));
  }, [products]);

  const onSelected = (data) => {
    if (products.length > 0) {
      setProducts([...products, data]);
    } else {
      setProducts(data);
    }
  };
  const showWindow = () => {
    setShow(!show);
  };

  const onOkModal = () => {
    if (productSelectOrder.length === 0) {
      confirm({
        title: "Lưu ý .Bạn chưa chọn sản phẩm!?",
        cancelText: "Hủy",
        okText: "Tiếp tục",
        onOk() {
          setShow(!show);
        },
        onCancel() {},
      });
    } else {
      console.log(productSelectOrder);
      if (products.length > 0) {
        setProducts([...products, ...productSelectOrder]);
      } else {
        setProducts(productSelectOrder);
      }
      setShow(!show);
    }
  };

  const onSelectType = (value, option) => {
    const newState = products.map((obj, index) => {
      const price = option.isPromotions ? option.salePrice : option.price;
      if (option.index === index) {
        return {
          ...obj,
          priceFinal: option.price,
          salePriceFinal: option.salePrice,
          originPrice: price,
          totalPrice: obj.quantity * price,
          idTypeSelect : option.id ?  option.id : null,
        };
      }
      return obj;
    });
    setProducts(newState);
  };

  const removeProduct = (index) => {
    const items = [...products];
    items.splice(index, 1);
    setProducts([...items]);
  };

  const changeQtyProduct = (value, index) => {
    const newState = products.map((obj, _index) => {
      if (index === _index) {
        return {
          ...obj,
          totalPrice: value * obj.originPrice,
          quantity: value,
        };
      }
      return obj;
    });
    setProducts(newState);
  };

  const forMap = (item, index) => {
    return (
      <tr key={index}>
        <td style={{ textAlign: "center" }}>
          <LocalImage
            src={item.avatar}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </td>

        <td style={{ textAlign: "center" }}>
          <b>{item.name}</b>
        </td>
        <td style={{ textAlign: "center" }}>
          {item.variant ? (
            <>
              <Select
                size="medium"
                style={{ width: 200 }}
                defaultValue=""
                onChange={onSelectType}
              >
                <Option
                  value=""
                  price={item.price}
                  salePrice={item.salePrice}
                  isPromotions={item.isPromotions}
                  index={index}
                  id=""
                >
                  ---Không chọn---
                </Option>

                {item.variant.types.map((_item, _index) => {
                  return (
                    <Option
                      key={_index}
                      value={_item.name}
                      price={_item.price}
                      salePrice={_item.salePrice}
                      isPromotions={item.isPromotions}
                      index={index}
                      id={_item.id}
                    >
                      {_item.name}
                    </Option>
                  );
                })}
              </Select>
            </>
          ) : null}
        </td>

        <td style={{ textAlign: "center" }}>
          {item.isPromotions ? (
            <>
              <span className="price-no-sale">
                {currencyFormat(item.priceFinal)}
              </span>
              <b> {currencyFormat(item.salePriceFinal)}</b>
            </>
          ) : (
            <b> {currencyFormat(item.priceFinal)}</b>
          )}
        </td>
        <td style={{ textAlign: "center" }}>
          <InputNumber
            min={1}
            defaultValue={item.quantity}
            size="large"
            onChange={(e) => {
              changeQtyProduct(e, index);
            }}
          />
        </td>
        <td style={{ textAlign: "center" }}>
          <b> {currencyFormat(item.totalPrice)}</b>
        </td>
        <td style={{ textAlign: "center" }}>
          <Button
            type="primary"
            size="small"
            danger
            onClick={() => {
              removeProduct(index);
            }}
          >
            <DeleteOutlined /> &nbsp; Xóa
          </Button>
        </td>
      </tr>
    );
  };

  const tagChild = products.map(forMap);

  return (
    <>
      <div>
        <Tag
          className="my-tag mt-10"
          onClick={showWindow}
          style={{ cursor: "pointer" }}
        >
          Chọn sản phẩm <PlusOutlined />
        </Tag>
        <br /> <br />
        <Card>
          {" "}
          <div className="product-tb">
            <table>
              <tbody>
                <tr>
                  <th style={{ width: 150, textAlign: "center" }}>
                    Ảnh sản phẩm
                  </th>
                  <th style={{ width: 250, textAlign: "center" }}>
                    Tên sản phẩm
                  </th>
                  <th style={{ width: 100, textAlign: "center" }}>Phân loại</th>
                  <th style={{ width: 250, textAlign: "center" }}>Đơn giá</th>
                  <th style={{ width: 100, textAlign: "center" }}>Số lượng</th>
                  <th style={{ width: 250, textAlign: "center" }}>Số tiền</th>
                  <th style={{ width: 100 }}>Hành động</th>
                </tr>
                {tagChild}
              </tbody>
            </table>
          </div>
        </Card>
        {show && (
          <Modal
            title=""
            visible={show}
            width={1300}
            onOk={() => {
              onOkModal();
            }}
            style={{ top: 20 }}
            // okButtonProps={{
            //   disabled: !products,
            // }}
            onCancel={() => {
              setShow(false);
            }}
            destroyOnClose={true}
          >
            <div style={{ padding: "15px" }}>
              <ProductSelectOrder onSelected={onSelected} />
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ProductUtil;
